import { register } from '@shopify/theme-sections'

import '../../styles/sections/section-collection-grid-info.scss'

export default register(`section-collection-grid-info`, {
    onLoad() {
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload() {
    },
})
